import { render, staticRenderFns } from "./vorgang-verlinkungen-basic.vue?vue&type=template&id=3b9f668c"
import script from "./vorgang-verlinkungen-basic.vue?vue&type=script&lang=js"
export * from "./vorgang-verlinkungen-basic.vue?vue&type=script&lang=js"
import style0 from "./vorgang-verlinkungen-basic.vue?vue&type=style&index=0&id=3b9f668c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports